import { getErrorMessages, useGetInvestmentQuery } from "../../../../services";
import { InvestmentsDetails } from "../../types";
import { UseInvestmentDataProps, UseInvestmentDataReturn } from "./types";

/**
 * Thin wrapper over the generated `useGetInvestmentQuery` — RTK Query fetches
 * on mount and refetches automatically when a mutation invalidates the
 * `Investment` tag, so there is no manual `useEffect`/`refetch` wiring here.
 */
export const useInvestmentData = ({
  id,
}: UseInvestmentDataProps): UseInvestmentDataReturn => {
  const {
    data,
    error: queryError,
    isLoading,
    isFetching,
    refetch,
  } = useGetInvestmentQuery(id);

  const investment = data ?? ({} as InvestmentsDetails);

  const errorMessages = queryError ? getErrorMessages(queryError as any) : [];
  const error = errorMessages[0] ?? null;

  return {
    investment,
    isLoading: isLoading || (isFetching && !data),
    error,
    notFoundError: error === "Investment not found",
    lastUpdated: data?.lastUpdateDate ? new Date(data.lastUpdateDate) : null,
    refetch: async () => {
      await refetch();
    },
  };
};
